module.exports = __webpack_public_path__ + "static/img/service3.dd5d66c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service3.png
// module id = BDhL
// module chunks = 0